import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CtrlIconComponent } from '@co-3/ctrl-ui/icons';
import { DamageReport, DamageReportState } from '@models/damage-report';
import { RouterLink } from '@angular/router';
import { PortalWidgetDetailsComponent } from 'app/customer-portal/components';

@Component({
    selector: 'app-reported-damages-list-item',
    imports: [DatePipe, CtrlIconComponent, PortalWidgetDetailsComponent, RouterLink],
    templateUrl: './reported-damages-list-item.component.html',
    styleUrl: './reported-damages-list-item.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportedDamagesListItemComponent {
    public damageReport = input.required<DamageReport>();

    protected damageState: typeof DamageReportState = DamageReportState;

    protected iconColor = computed(() => {
        switch (this.damageReport().state) {
            case DamageReportState.COMPLETED:
                return 'c:green';
            case DamageReportState.IN_PROGRESS:
                return 'c:orange';
            case DamageReportState.REPORTED:
                return 'c:blue-700';
        }
    });
}
